/**
 * "Submittal Package already generating" popup — 1:1 port of
 * report/mvc/tmpl/information_popup.tmpl, appended to #main_content on the
 * 'show:report:generation:popup' dispatch (view/main.js:57-59) when the 1h
 * guard trips (controller/action.js:213-218). Close (#btn_cancel, also the
 * ESC target via the shared popup-keys handler) removes it (main.js:219-221).
 */
interface ReportGenerationPopupProps {
  onClose: () => void;
}

const ReportGenerationPopup = ({ onClose }: ReportGenerationPopupProps) => (
  <div className="report-generation-popup popup-wrapper width-small active">
    <div className="popup-content-part popup-content">
      <h2 className="popup-heading">Submittal Package Report </h2>
      <p className="heads_up">Heads Up!</p>
      <p>A version of this Submittal Package Report is already in the process of being generated.</p>
      <p className="empty-row">Empty</p>
      <p>Please wait until the report generation is completed,</p>
      <p>in order to generate it again.</p>
      <div className="popup-control-buttons">
        <button
          type="button"
          className="btn right btn_cancel highlighted-btn"
          id="btn_cancel"
          name="cancel_delete"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  </div>
);

export default ReportGenerationPopup;
